import { useEffect } from "react";
import { Link } from "react-router-dom";
import { COMPANY_INFO } from "../data/siteData";

export default function ForbiddenPage() {
  useEffect(() => {
    document.title = "403 - Adgang nægtet | Kærby Tømrer- & Snedkerforretning ApS";
  }, []);

  return (
    <div className="bg-[#f8f7f4] min-h-[75vh] flex items-center justify-center py-20 px-4">
      <div className="max-w-2xl w-full bg-white rounded-2xl border border-[#e2dfd7] shadow-xl p-8 sm:p-12 text-center space-y-8">
        
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-red-50 border border-red-200 px-4 py-1.5 rounded-full text-sm font-bold text-red-700">
          <i className="fa-solid fa-lock" aria-hidden="true" />
          <span>Fejlmeddelelse 403 — Adgang Nægtet</span>
        </div>

        <div className="space-y-3">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-[#16181b] tracking-tight">
            Ingen adgang til den anmodede ressource
          </h1>
          <p className="text-gray-600 text-base max-w-md mx-auto leading-relaxed">
            Du har desværre ikke den nødvendige tilladelse til at tilgå denne side.
          </p>
        </div>

        {/* Action Button */}
        <div className="pt-2">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-[#d96b27] hover:bg-[#c25a1f] text-white font-bold uppercase tracking-wider text-sm sm:text-base px-8 py-3.5 rounded-md shadow-md transition-all"
          >
            <i className="fa-solid fa-house text-sm" aria-hidden="true" />
            <span>Gå til Forsiden</span>
          </Link>
        </div>

        <div className="text-xs text-gray-400 pt-4 border-t border-gray-100">
          Hvis du mener dette er en fejl, kan du ringe til os på{" "}
          <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="font-bold text-[#16181b] underline whitespace-nowrap">
            {COMPANY_INFO.phone}
          </a>
        </div>

      </div>
    </div>
  );
}
